import type { Table } from "@tanstack/react-table";
import type { ICotizacion } from "../../../modelos/Cotizador/entidades/ICotizacion";

export interface ITablaCotizacionesVistaProps extends IFiltroCotizacionesVistaProps {
    tabla: Table<ICotizacion>;
    habilitarFiltros: boolean;
    manejarHabilitarFiltros: (habilitar: boolean) => void;
    seleccionadas: ICotizacion[];
    manejarSeleccion: (cotizacion: ICotizacion) => void;
    manejarSeleccionMasiva: (seleccionarTodos: boolean) => void;
    aprobarRechazarCotizaciones: (cotizacion: ICotizacion[], aprobar: boolean) => void;
    aprobarCotizacion: (cotizacion: ICotizacion) => void;
    // aprobarCotizacionesMasivas: () => void;
    rechazarCotizacion: (cotizacion: ICotizacion) => void;
}

export interface ICotizadorCVProps {
    nombreTabla: string;
}

export const estadoInicialCotizacion: ICotizacion = {
    Id: 0,
    IdSolicitud: 0,
    CodigoServicio: 0,
    FechaCreacion: "",
    TecnicoSolicita: "",
    Repuesto: "",
    Cantidad: 0,
    PrecioVenta: 0,
    FechaAprobacion: null,
    Aprobada: false,
    Eliminado: false,
    CreadoUtc: new Date().toISOString(),
    ActualizadoUtc: new Date().toISOString(),
};

export interface IFiltroCotizacionesVistaProps {
    filtro: ICotizacion;
    consultarCotizaciones: () => void;
    manejarCambioFiltroCotizacion: (campo: keyof ICotizacion, valor: ICotizacion[keyof ICotizacion]) => void;
}
